import { useNavigate } from "react-router-dom";
import {
  Sparkles,
  ScanLine,
  ListChecks,
  FileText,
  PenLine,
  Presentation,
  Languages,
  MessageSquare,
  Wand2,
} from "lucide-react";

/**
 * QuickActionBar — sticky shelf of one-click AI shortcuts to render at the top
 * of inner workspace pages (OCR, Knowledge Hub, Assessment, etc).
 *
 * props:
 *   exclude?: string[]  — action keys to hide on a given page
 *   testid?: string
 */
const ACTIONS = [
  { key: "tfa",       label: "Teach from anything", icon: Wand2,         route: "/teach-from-anything",                color: "tb-chip-lavender" },
  { key: "scan",      label: "Scan document",       icon: ScanLine,      route: "/ocr",                                color: "tb-chip-mint" },
  { key: "lesson",    label: "Lesson plan",         icon: PenLine,       route: "/teaching-assistant?tool=lesson_plan",color: "tb-chip-lavender" },
  { key: "mcq",       label: "Generate MCQs",       icon: ListChecks,    route: "/teaching-assistant?tool=mcq",        color: "tb-chip-sky" },
  { key: "worksheet", label: "Worksheet",           icon: FileText,      route: "/teaching-assistant?tool=worksheet",  color: "tb-chip-butter" },
  { key: "ppt",       label: "Presentation",        icon: Presentation,  route: "/content-studio",                     color: "tb-chip-mint" },
  { key: "translate", label: "Translate",           icon: Languages,     route: "/teaching-assistant?tool=lesson_plan",color: "tb-chip-sky" },
  { key: "parent",    label: "Parent message",      icon: MessageSquare, route: "/parent-comms",                       color: "tb-chip-rose" },
];

export default function QuickActionBar({ exclude = [], testid = "quick-action-bar" }) {
  const navigate = useNavigate();
  const visible = ACTIONS.filter((a) => !exclude.includes(a.key));

  return (
    <div className="mb-5" data-testid={testid}>
      <p className="text-[10px] uppercase tracking-[0.25em] font-semibold text-muted-foreground inline-flex items-center gap-2 mb-2">
        <Sparkles className="h-3 w-3" /> Quick actions
      </p>
      <div className="flex flex-wrap gap-2 -mx-1 px-1 pb-1">
        {visible.map((a) => {
          const Icon = a.icon;
          return (
            <button
              key={a.key}
              onClick={() => navigate(a.route)}
              className="tb-action-chip shrink-0"
              data-testid={`qab-${a.key}`}
            >
              <span className={`inline-grid place-items-center h-6 w-6 rounded-full ${a.color}`}>
                <Icon className="h-3.5 w-3.5" />
              </span>
              {a.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
